<template>
  <transition name="modal">
    <div class="modal-mask" @mousedown="e => closeModal(e, 'down')" @mouseup="e => closeModal(e, 'up')">
      <div class="modal-wrapper" :class="{ 'auto-height': autoHeight }">
        <div class="modal-container" :style="containerStyle">
          <slot></slot>
          <dialogLoading v-if="isDialogLoading"></dialogLoading>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import dialogLoading from './loading.vue'

export default {
  components: {
    dialogLoading
  },
  props: {
    width: {
      type: String,
      default: () => '400px'
    },
    height: {
      type: String,
      default: () => 'auto'
    },
    customStyles: {
      type: Object,
      default: () => ({})
    },
    maskClose: {
      type: Boolean,
      default: () => true
    },
    autoHeight: {
      type: Boolean,
      default: () => true
    }
  },
  data () {
    return {
      onClose: false
    }
  },
  computed: {
    ...mapGetters([
      'isDialogLoading'
    ]),
    containerStyle () {
      return { ...this.customStyles, height: this.height, width: this.width }
    }
  },
  methods: {
    closeModal (e, type) {
      if (this.maskClose) {
        if (!['modal-mask', 'modal-wrapper', 'modal-wrapper auto-height'].includes(e.target.className)) {
          this.onClose = false
          return
        }
        if (type === 'down') {
          this.onClose = true
        } else if (this.onClose) {
          this.$emit('hide')
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  .modal-mask
    position: fixed
    height: 100vh
    overflow: auto
    z-index: 9996
    top: 0
    left: 0
    width: 100%
    min-height: 100%
    background-color: rgba(0, 54, 121, .5)
    transition: opacity .3s ease
    &::-webkit-scrollbar
      height: 0
  .modal-wrapper
    display: inline-block
    width: 100%
    height: 100%
    vertical-align: middle
    &.auto-height
      height: auto
  .modal-container
    position: relative
    max-width: 95%
    // max-height: calc(100% - 160px)
    margin: 80px auto
    padding: 20px
    background-color: white
    border-radius: 20px
    box-shadow: 0 3px 6px rgba(0, 0, 0, .16)
    box-sizing: border-box
    // overflow: auto
    transition: all .3s ease
    // @media screen and (max-width: 1000px)
    //   margin: 15% auto
  .modal-enter
    opacity: 0
  .modal-leave-active
    opacity: 0
  .modal-enter .modal-container,
  .modal-leave-active .modal-container
    -webkit-transform: scale(1.1)
    transform: scale(1.1)
    // @media screen and (max-width: 1000px)
    //   -webkit-transform: scale(0.9)
    //   transform: scale(0.9)
</style>



// WEBPACK FOOTER //
// src/components/dialog/container.vue